import styled from 'styled-components'

export const InvoiceExportWrapper = styled.div`
  th {
    text-align: center;
  }
  .SearchAndFilters { margin-left: 65px },
`



// WEBPACK FOOTER //
// ./src/Components/Settings/InvoiceExport/InvoiceExportWrapper/index.js